/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_View_AgendaInputs */

const en_calendar_view_agenda = /** @type {(inputs: Calendar_View_AgendaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenda`)
};

const pt_br2_calendar_view_agenda = /** @type {(inputs: Calendar_View_AgendaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenda`)
};

/**
* | output |
* | --- |
* | "Agenda" |
*
* @param {Calendar_View_AgendaInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const calendar_view_agenda = /** @type {((inputs?: Calendar_View_AgendaInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_View_AgendaInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_view_agenda(inputs)
	return pt_br2_calendar_view_agenda(inputs)
});